module.exports = "<div class=\"wrapper\">\n  <div class=\"side top\"></div>\n  <div class=\"side right\">\n      <div class=\"side front\"></div>\n      <div class=\"side back\"></div>\n  </div>\n  <div class=\"side left\"></div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader?interpolate!./src/components/brick/templates/brick.html
// module id = 43
// module chunks = 0